/* Vitti customer stories: native CSS scroll-snap handles scrolling.
   JavaScript is ONLY for chevron buttons. No drag handlers, active-state
   tracking, scroll listeners or resizing logic. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-vitti-stories-prev], [data-vitti-stories-next]');
  if (!button) return;

  const section = button.closest('[data-vitti-home-stories]');
  const rail = section?.querySelector('[data-vitti-stories-rail]');
  const slides = rail?.querySelectorAll('[data-vitti-story-slide]');
  if (!rail || !slides || slides.length < 2) return;

  const step = slides[1].offsetLeft - slides[0].offsetLeft;
  if (!step) return;

  const direction = button.hasAttribute('data-vitti-stories-next') ? 1 : -1;
  const currentIndex = Math.round(rail.scrollLeft / step);
  const targetIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + direction));

  rail.scrollTo({
    left: targetIndex * step,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
});